import * as deviceDetect from 'react-device-detect';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import { useState, useEffect } from 'react';
import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import css from './index.module.scss';
import Bannervideo from './components/bannervideo';
import OthersSaying from './components/othersSaying';
import ExpandableCapacity from './components/expandableCapacity';
import Recommend from './components/recommend';
// import AsEasy from './components/asEasy';
// import HomeLight from './components/homeLight';
import Solutions from './components/solutions';
import SolutionsDetail from './components/solutionsDetail';
import Ecosystem from './components/Ecosystem';
import UsersVideos from './components/UsersVideos';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useGlobal } from '@/utils/useGlobal';

if (typeof window !== 'undefined') {
    window.ScrollMagic = ScrollMagicFn();
    ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
}

export default function DeltaproWholeHome() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const SHOW_TS_BUNDLE_SITE = ['sa', 'za', 'au'].includes(locale);
    const [isIOS, setIsIOS] = useState<boolean>(false);

    useEffect(() => {
        setIsIOS(deviceDetect.isIOS);
    }, []);

    return (
        <>
            <div className={`${css.deltaproWholeHome} deltapro-wrapper ${isIOS ? ' isIOS' : ''}`}>
                <div className={`${isIOS ? ' isIOS' : ''}`}>
                    <Bannervideo />
                    {locale === 'ca' && <MemberDrainageBar />}
                    {locale !== 'ca' && <OthersSaying />}
                    <ExpandableCapacity />
                    {locale === 'ca' && <OthersSaying />}
                    {!SHOW_TS_BUNDLE_SITE && locale !== 'ca' && <Recommend />}
                    {/* <AsEasy /> */}
                    <Solutions />
                    <SolutionsDetail />
                    {!['sa'].includes(locale) && <Ecosystem />}
                    <UsersVideos />
                    {/* <HomeLight /> */}
                </div>
            </div>
        </>
    );
}
